var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { BaseModalContentColumn, SecondaryText, Title, } from "../../designSystem";
var InfoColumn = styled(BaseModalContentColumn).attrs({
    className: "d-flex w-100 align-items-center justify-content-between",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var InfoData = styled(Title)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-transform: none;\n"], ["\n  text-transform: none;\n"])));
var ModalInfoColumn = function (_a) {
    var label = _a.label, data = _a.data, _b = _a.type, type = _b === void 0 ? "primary" : _b, marginTop = _a.marginTop;
    return (_jsxs(InfoColumn, __assign({ marginTop: marginTop }, { children: [_jsx(SecondaryText, { children: label }, void 0), _jsx(InfoData, { children: data }, void 0)] }), void 0));
};
export default ModalInfoColumn;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ModalInfoColumn.js.map